import React from 'react';
import classes from '../../css/Us.module.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

const Us = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div>
      <Helmet>
        <title>Backend Helpers Limited | us </title>
      </Helmet>
      <div className={classes.languageButtons}>
        <Link to="/es">
          <button
            type="button"
            onClick={() => changeLanguage('es')}
            className={classes.button_lang}
          >
            es
          </button>
        </Link>
      </div>

      <main className={classes['main-content']}>
        <section id="index" className={`${classes.container} ${classes.index}`}>
          <div className={classes['contact-left']}>
            <h1 className={classes['rw-sentence']}>
              We deliver <br />
              <span className={classes['bg-title']}> your VISION</span>
              <br />
              To The Cloud
            </h1>
          </div>

          <div
            className={`${classes['col-6']} ${classes['col-s-12']} ${classes['padding-1']}`}
          >
            <h2 className={classes['text-left']}>WHO WE ARE</h2>
            <p className={classes.who}>
              From
              <span className={classes.negrilla}> legacy migration </span> to
              <span className={classes.negrilla}> greenfield deployment, </span>
              we rapidly transform
              <span className={classes.negrilla}>
                {' '}
                your systems for the cloud.{' '}
              </span>
              We are an{' '}
              <span className={classes.negrilla}>
                automation-powered factory,{' '}
              </span>
              focused on delivering
              <span className={classes.negrilla}>
                {' '}
                secure, reliable, and cost-efficient{' '}
              </span>
              cloud solutions.
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Us;
